<template>
  <div>
    <!--
    <el-table
      :data="list"
      :header-cell-style="headClass"
      :cell-style="cellStyle"
      stripe
      border
      fit
      v-loading="loading"
      element-loading-text="拼命加载中"
      :span-method="objectSpanMethod"
      style="width: 100%; font-size: 12px"
    >
      <el-table-column align="center" prop="type" label="服务类别">
        <template slot-scope="scope">
          <span v-if="scope.row.type == '0'">基础服务</span>
          <span v-if="scope.row.type == '1'">基础服务</span>
          <span v-if="scope.row.type == '2'">提升服务</span>
          <span v-if="scope.row.type == '3'">专属服务</span>
          <span v-if="scope.row.type == '4'">推广服务</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="name"
        label="服务内容"
      ></el-table-column>
      <el-table-column align="center" prop="personal" label="个人会员">
        <template slot-scope="scope">
          <span :class="[scope.row.personal == undefined ? 'err' : '']">{{
            scope.row.personal == undefined ? "x" : scope.row.personal
          }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="personalVip" label="个人付费 会员">
        <template slot-scope="scope">
          <span :class="[scope.row.personalVip == undefined ? 'err' : '']">{{
            scope.row.personalVip == undefined ? "x" : scope.row.personalVip
          }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="expert" label="专家">
        <template slot-scope="scope">
          <span :class="[scope.row.expert == undefined ? 'err' : '']">{{
            scope.row.expert == undefined ? "x" : scope.row.expert
          }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="enterprise" label="企业会员">
        <template slot-scope="scope">
          <span :class="[scope.row.enterprise == undefined ? 'err' : '']">{{
            scope.row.enterprise == undefined ? "x" : scope.row.enterprise
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="enterpriseVip"
        label="企业付费 会员"
      >
        <template slot-scope="scope">
          <span :class="[scope.row.enterpriseVip == undefined ? 'err' : '']">{{
            scope.row.enterpriseVip == undefined ? "x" : scope.row.enterpriseVip
          }}</span>
        </template>
      </el-table-column>
    </el-table>
    -->
  <table  border="1" cellspacing="0" cellpadding="0" >
    <tr  style="background-color: #FF7302;font-size: 14px;color:#ffffff;"><th style="width:100px">&nbsp;&nbsp;服务类别&nbsp;&nbsp;</th><th>服务内容</th><th>个人会员</th><th>个人V会员</th><th>专家</th><th>企业会员(普通)</th><th>企业VIP会员</th></tr>
    <tr v-for="(item ,index) in slist" :key="item.id" :style="0==index%2?'':'background-color:#fffeee'">
      <td :class="'tpye_'+item.type" >{{authtypes[item.type]}}</td>
      <td>{{item.name}}</td>
      <td v-if="undefined==item.r1 || null==item.r1 || 0==item.r1 " style="color:red" >&#10006;</td><td v-else-if="1==item.r1" style="color:green" >&#10004;</td>   <td v-else>{{item.r1}}</td>
      <td v-if="undefined==item.r2 || null==item.r2 || 0==item.r2 " style="color:red" >&#10006;</td><td v-else-if="1==item.r2" style="color:green" >&#10004;</td>   <td v-else>{{item.r2}}</td>
      <td v-if="undefined==item.r3 || null==item.r3 || 0==item.r3 " style="color:red" >&#10006;</td><td v-else-if="1==item.r3" style="color:green" >&#10004;</td>   <td v-else>{{item.r3}}</td>
      <td v-if="undefined==item.r4 || null==item.r4 || 0==item.r4 " style="color:red" >&#10006;</td> <td v-else-if="1==item.r4" style="color:green" >&#10004;</td>   <td v-else>{{item.r4}}</td>
      <td v-if="undefined==item.r5 || null==item.r5 || 0==item.r5 " style="color:red" >&#10006;</td><td v-else-if="1==item.r5" style="color:green" >&#10004;</td>   <td v-else>{{item.r5}}</td>

    </tr>
  </table>
  </div>
</template>
<script>
import { authlist, serverlist } from "@/api/coment";
export default {
  props: {},
  data() {
    return {
      authtypes:["形象展示","基础服务","提升服务","专属服务","推广服务"],
      position: 0,
      rowSpanArr: [],
      tableData: [],
      loading: true,
      slist:[],
      list: [],
      data: [],
      roleValue: [],
      roleList: [
        {
          name: "个人会员",
          key: "personal",
        },
        {
          name: "个人V会员",
          key: "personalVip",
        },
        {
          name: "专家",
          key: "expert",
        },
        {
          name: "企业会员",
          key: "enterprise",
        },
        {
          name: "企业V会员",
          key: "enterpriseVip",
        },
      ],
    };
  },
  created() {
    this.getServerlist();

    //this.getRowSpan();
  },
  watch: {
  },
  mounted(){

  },
  methods: {
    settype(){
      this.$nextTick(() => {
          for (let i = 0; i < 5; i++) {
            let tcls="tpye_"+i;
            let tl=window.document.getElementsByClassName(tcls).length;
            if(tl>0){
              for (let index = 0; index <tl; index++) {
                if(0==index){
                      window.document.getElementsByClassName(tcls)[index].setAttribute("rowspan",tl);
                      window.document.getElementsByClassName(tcls)[index].setAttribute("style","background:#F7F7F7")
                }else{
                    window.document.getElementsByClassName(tcls)[index].setAttribute("style","display: none");
                }
              }
            }

          }

      })
    },
    getServerlist() {
      serverlist()
        .then((res) => {
          if (res.code == 0) {
            //  this.data = this.repeat(res.data);
            this.slist=res.data;
            this.getAuthlist();
            //this.getAuthlist();
          }
        })
        .catch((err) => {});
    },
    //获取会员权益
    getAuthlist() {
      authlist().then((res) => {
        if (res.code == 0) {
          this.roleValue = res.data;
          //this.list = this.handleRoleValue();
          this.updateslist();
        }
      });
    },
    updateslist(){
        this.slist.forEach(element=>{
          element.r1=this.getmsgfromroleValue(1,element);
          element.r2=this.getmsgfromroleValue(2,element);
          element.r3=this.getmsgfromroleValue(3,element);
          element.r4=this.getmsgfromroleValue(4,element);
          element.r5=this.getmsgfromroleValue(5,element);
        })
        this.$forceUpdate();
        this.settype();
    },
    getmsgfromroleValue(roleId,serveritem){
      for (let index = 0; index < this.roleValue.length; index++) {
        let element = this.roleValue[index];
        if(null==serveritem.existchild && serveritem.id==element.authId && roleId== element.roleId){
          return 1;
        }else if(null!=serveritem.existchild && serveritem.existchild.length>0){
           // && serveritem.pid==element.authId && roleId== element.roleId
           //console.log(this.getchildmsgfromrolevalue(serveritem.existchild,roleId));
           return this.getchildmsgfromrolevalue(serveritem.existchild,roleId);
        }
      }
      return 0;
    },
    getchildmsgfromrolevalue(childitem,roleid){
      for (let index = 0; index < this.roleValue.length; index++) {
          let ritem=this.roleValue[index];
          for (let index2 = 0; index2 < childitem.length; index2++) {
              let element2 = childitem[index2];
              if( ritem.authId==element2.id ){
                  if(roleid==ritem.roleId){
                      return element2.msg;
                  }
              }
          }
      }


    },
    handleRoleValue() {
      return this.data.map((item) => {
        let itemRow = item;

        this.roleList.map((it) => {
          let itemValue =
            this.roleValue[it.name].filter((its) => {
              return item.authId == its.authId;
            })[0].authName || "";
          this.$set(itemRow, it.key, itemValue);
        });
        return itemRow;
      });
    },
    headClass() {
      return "background:#FF7402;text-align:center;color:white;";
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return "background:#F7F7F7";
      } else {
        return "";
      }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      let { tableData } = this;
      // if (columnIndex === 0) {
      //   return {
      //     rowspan: this.rowSpanArr[rowIndex],
      //     colspan: 1,
      //   };
      // }
    },
    //合并数组
    getRowSpan() {
      this.tableData.forEach((item, index) => {
        if (index == 0) {
          this.rowSpanArr.push(1);
          this.position = 0;
        } else {
          if (this.tableData[index].type == this.tableData[index - 1].type) {
            this.rowSpanArr[this.position] += 1; //项目名称相同，合并到同一个数组中
            this.rowSpanArr.push(0);
            this.tableData[index].type = this.tableData[index - 1].type;
          } else {
            this.rowSpanArr.push(1);
            this.position = index;
          }
        }
      });
    },

  },
};
</script>
<style scoped ="scoped">
/*  斑马纹表格背景 */
/deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
  /* background: #fff8f2; */
  background: #FFF8F2;
}

.default {
  color: rgba(102, 102, 102, 1);

}
.err {
  color: #ef9c9a;
}
.yes {
  color: #56c451;
}

table{
  border-collapse:collapse;
}

table th{
  padding: 5px 2px ;
  border: 1px solid #F7F7F7;
}
table td{
  padding: 5px 12px ;
  border: 1px solid #F7F7F7;
}

/deep/.el-loading-spinner .el-loading-text {
  color: #3bae30;
}
</style>



// WEBPACK FOOTER //
// src/components/moreTable.vue